import React, { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { toast } from "react-toastify";
import useApi from '../../../hooks/useApi';
import { baseUrl } from '../../../constants/endpoints';

const DeliverySetPass = () => {
    const api = useApi();
    const [searchParams] = useSearchParams();
    const user_id = searchParams.get("id");
    const user_name = searchParams.get("name");

    const [modalData, setModalData] = useState({});

    const handleChangeModalData = (name, value) => {
        setModalData({ ...modalData, [name]: value });
    };

    const handleSubmitSetPassword = async (e) => {
        e.preventDefault();
        if (modalData?.password !== modalData?.confirm_password) {
            toast.error("Password does not match", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
                theme: "colored",
            });
            return;
        }
        const { data } = await api.post(`${baseUrl}/api/delivery-staff/set-password`, {
            user_id,
            password: modalData?.password
        });
        if (data) {
            toast.success(data?.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
                theme: "colored",
            });
            window.location.href = '/';
        }
    }

    return (
        <div className="login-img">
            <div className="page">
                <div className="" style={{ marginBottom: 30 }}>
                    <div className="col col-login mx-auto">
                        <div className="text-center">
                            <img
                                src={require("../../../assets/images/brand/logo.png")}
                                className="header-brand-img"
                                alt=""
                            />
                            <h3 className='text-center mb-3 mt-5 text-white fw-bold'>Set Your Delivery App Password</h3>
                        </div>
                    </div>
                </div>
                <div>
                    <h4 className='text-center mb-0 text-white fw-500'>Hi {user_name},</h4>
                    <p className='text-center text-white fw-500 fs-16 mb-1'> Set your delivery app password & try login again in app.</p>
                    <form id="form" onSubmit={handleSubmitSetPassword} validate style={{ width: "100%", display: "flex", flexDirection: 'column', alignItems: "center", justifyContent: 'center', paddingRight: 10, paddingLeft: 10 }}>
                        <div className="col-lg-4 col-md-6 col-sm-12 form-group mb-2">
                            <label htmlFor="password" className="form-label text-white">Password</label>
                            <input className="form-control" type="password"
                                id="password"
                                placeholder="Enter Password"
                                name="password"
                                value={modalData?.password}
                                onChange={(e) => handleChangeModalData('password', e.target.value)}
                                required
                            />
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 form-group mb-4">
                            <label htmlFor="confirm_password" className="form-label text-white">Confirm Password</label>
                            <input className="form-control" type="password"
                                id="confirm_password"
                                placeholder="Confirm Password"
                                name="confirm_password"
                                value={modalData?.confirm_password}
                                onChange={(e) => handleChangeModalData('confirm_password', e.target.value)}
                                required
                            />
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 form-group">
                            <button type="submit" className="btn btn-primary w-100"><span style={{ color: "black", fontWeight: "bold", fontSize: "14px" }}>Set Password</span></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default DeliverySetPass;
